<div class="card-main">
  <app-title [titleRouter]="'Buscador de Personas'"></app-title>

  <form [formGroup]="searchPersonForm" (ngSubmit)="onSubmit()" class="container-fluid mx-0 px-0">

    <div class="row container-search px-4">
      <div
        [ngClass]="{'col-lg-6': (showInput === '' || showInput === 'commercial' || showInput === 'advanced'), 'col-lg-4 ': (showInput !== '' && showInput !== 'advanced')}">
        <efx-dropdown controlId="selectIdSubDomain" controlName="selectIdSubDomain" name="selectIdSubDomain"
          id="selectIdSubDomain" [selectedId]="options[0].key" [label]="'Búsqueda por'" [formGroup]="searchPersonForm"
          [isRequired]="true" [options]="options" bindId="key" bindDescription="name" [fullWidth]="true"
          [placeholder]="'Seleccione una opción'"
          [validationOptions]="{ required: { message: 'Por Favor seleccione una opción' } }"
          (change)="resetMensajes($event)">
        </efx-dropdown>
      </div>

      <div [ngClass]="{'col-lg-6': showInput === '', 'd-none': showInput !== ''}">
        <div class="m-0 p-0">
          <div>
            <label class="efx-label" for="idNumber">Parámetro de Búsqueda</label>
            <efx-text-field class="w-100" placeholder="Ingresar parámetro" controlId="idNumber" controlName="idNumber"
              [formGroup]="searchPersonForm" name="idNumber" id="idNumber" [(value)]="resultInput" [isRequired]="true"
              [validationOptions]="{
                required: { message: 'Parámetro de Búsqueda' }
              }">
            </efx-text-field>

          </div>
        </div>
      </div>

      @if (showInput === 'advanced') {
        @for (field of advancedFieldsSorted; track field.name) {
          <div class="col-lg-6">
            <div class="m-0 p-0">
              <div>
                <label class="efx-label" [for]="field.name.toUpperCase()">{{ field.label }}</label>
                <efx-text-field class="w-100" [placeholder]="field.label" [controlId]="field.name.toUpperCase()"
                  [controlName]="field.name.toUpperCase()" [formGroup]="searchPersonForm"
                  [name]="field.name.toUpperCase()" [id]="field.name.toUpperCase()" [isRequired]="field.required"
                  (input)="forceUpperCase(field.name.toUpperCase(), $event)"
                  (valueChange)="syncDynamicValue(field.name.toUpperCase(), $event)" [validationOptions]="{
                         required: { message: 'Ingrese ' + field.label }
                      }">
                </efx-text-field>
              </div>
            </div>
          </div>
        }

        @for (ident of identifiersFieldsSorted; track ident.name) {
          <div class="col-lg-6">
            <div class="m-0 p-0">
              <div>
                <label class="efx-label" [for]="ident.name.toUpperCase()">{{ ident.label }}</label>
                <efx-text-field class="w-100" [placeholder]="ident.label" [controlId]="ident.name.toUpperCase()"
                  [controlName]="ident.name.toUpperCase()" [formGroup]="searchPersonForm"
                  [name]="ident.name.toUpperCase()" [id]="ident.name.toUpperCase()" [isRequired]="ident.required"
                  (input)="forceUpperCase(ident.name.toUpperCase(), $event)"
                  (valueChange)="syncDynamicValue(ident.name.toUpperCase(), $event)" [validationOptions]="{
                         required: { message: 'Ingrese ' + ident.label }
                      }">
                </efx-text-field>
              </div>
            </div>
          </div>
        }
      }

      @if (showInput === 'consumer') {
        <div class="col-lg-4 ">
          <div class="m-0 p-0">
            <div>
              <label class="efx-label" for="name">Primer Nombre</label>
              <efx-text-field class="w-100" placeholder="Ingresar parámetro" controlId="name" controlName="name"
                [formGroup]="searchPersonForm" name="name" id="name" [isRequired]="true" [validationOptions]="{
                required: { message: 'Ingrese Primer Nombre' }
              }">
              </efx-text-field>
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="m-0 p-0">
            <div>
              <label class="efx-label" for="secondName">Segundo Nombre</label>
              <efx-text-field class="w-100" placeholder="Segundo Nombre" controlId="secondName" controlName="secondName"
                [formGroup]="searchPersonForm" name="secondName" id="secondName" [validationOptions]="{
                required: { message: 'Ingrese Segundo Nombre' }
              }">
              </efx-text-field>
            </div>
          </div>
        </div>
        <div class="col-lg-4 ">
          <div class="m-0 p-0">
            <div>
              <label class="efx-label" for="name">Primer apellido</label>
              <efx-text-field class="w-100" placeholder="Ingresar parámetro" controlId="surname" controlName="surname"
                [formGroup]="searchPersonForm" name="surname" id="surname" [isRequired]="true" [validationOptions]="{
                required: { message: 'Ingrese Primer apellido' }
              }">
              </efx-text-field>
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="m-0 p-0">
            <div>
              <label class="efx-label" for="secondSurname">Segundo apellido</label>
              <efx-text-field class="w-100" placeholder="Segundo apellido" controlId="secondSurname"
                controlName="secondSurname" [formGroup]="searchPersonForm" name="secondSurname" id="secondSurname"
                [validationOptions]="{
                required: { message: 'Ingrese Segundo apellido' }
              }">
              </efx-text-field>
            </div>
          </div>
        </div>
      }


      @if (showInput === 'commercial') {
        <div class="col-lg-6">
          <div class="m-0 p-0">
            <div>
              <label class="efx-label" for="companyName">Razón Social</label>
              <efx-text-field class="w-100" placeholder="Razón Social" controlId="companyName" controlName="companyName"
                [formGroup]="searchPersonForm" name="companyName" id="companyName" [isRequired]="true"
                [validationOptions]="{
                required: { message: 'Ingrese la Razón Social' }
              }">
              </efx-text-field>
            </div>
          </div>
        </div>
      }




      <div class="col-lg-12 ">
        <div class="d-flex justify-content-end  align-items-center">
          <button type="submit" class="efx-button-primary" [disabled]="searchPersonForm.invalid">BUSCAR</button>
        </div>

      </div>
    </div>

    <div class="container-table mx-0 px-0">
      @if (showResultTable) {
        <table class="efx-table" aria-label="Results Table">
          <ng-container>
            <thead>
              <tr>
                @for (col of resultsTable.cols; track col) {
                  <th class="{{col.classAttribute}}">
                    @if (col.tooltip) {
                      <div class="d-flex align-items-center container-table-iup">
                        {{col.title}}
                        <label efxTooltip efxTooltipTitle="{{col.tooltip}}" efxTooltipPlacement="bottom"
                          efxTooltipMode="dark">
                          <span class="material-symbols-outlined ms-1 container-table-iup-tooltip">
                            info
                          </span>
                        </label>
                      </div>
                    }
                    @if (!col.tooltip) {
                      <span>{{col.title}}</span>
                    }
                  </th>
                }
              </tr>
            </thead>
          </ng-container>
          <tbody>
            <ng-container>
              @for (row of resultsTable.rows; track row) {
                <tr class="cursor-pointer tr-body" (click)="goToNextPage(row.persona)"
                  >
                  @for (c of resultsTable.cols; track c) {
                    <td class="result-cell">
                      {{ getAttributeName(row.persona, c.attributeName) | titlecase }}
                    </td>
                  }
                </tr>
              }
            </ng-container>
          </tbody>
        </table>
      }
      @if (!showResultTable && !showSinResultado ) {
        <div
          class="d-flex container-table-alert flex-column align-items-center justify-content-center">
          <span class="material-symbols-outlined"> error </span>
          <p>Debe ingresar un parámetro de búsqueda </p>
        </div>
      }
      @if (showSinResultado) {
        <div class="w-100 text-center mt-3">
          <h6>No se encontraron datos.</h6>
        </div>
      }
      @if (showSinResultado && profileSelected.addEntidad) {
        <div class="w-100 text-center">
          <h6>¿Desea crear una nueva entidad?</h6>
          <button class="efx-button-secondary" (click)="altaEntidades()">Crear nueva entidad</button>
        </div>
      }
    </div>
  </form>
</div>

<efx-modal [(show)]="showModal" [size]="modalSize.medium" [showFooter]="true" [showSubmit]="true" [showClose]="true"
  submitLabel="Cerrar" title=" " (submit)="closeModal()" (onHide)="closeModal()" (cancel)="closeModal()">
  <div class="d-flex flex-column align-items-center">
    @if (showimgModal) {
      <img src="assets/images/deleted_modal.svg" alt="" />
    }
    <section class="m-0 text-center mt-3">
      <p class="m-0" style="font-size: 1.5rem;"><strong [innerHTML]="tituloModal"></strong></p> <br>
      <p class="m-0" [innerHTML]="bodyModal"></p>
    </section>
  </div>
</efx-modal>

<!-- Modal de selección de configuraciones -->
<app-modal-config-selection
  [showModal]="showConfigModal"
  [availableConfigs]="availableConfigs"
  [fuenteName]="profileSelected?.labelDropDown || 'Fuente'"
  [loading]="loadingConfigs"
  (modalClose)="closeConfigModal()"
  (configSelected)="onModalConfigSelected($event)">
</app-modal-config-selection>

